import { useLazyGetChatSessionDetailQuery } from 'services';

export function useLazyChatSessionDetail() {
  const [trigger, { data: chatSessionResponse, isLoading }] = useLazyGetChatSessionDetailQuery();

  const handleLoadChatSessionDetail = async (chatSessionId: number) => {
    if (!chatSessionId) return null;
    const response = await trigger(chatSessionId).unwrap();
    return response.data;
  };

  return {
    loadChatSessionDetail: handleLoadChatSessionDetail,
    data: chatSessionResponse?.data,
    isLoading
  };
}
